<template lang="jade">
  .mcl-wrapper
    .input-group
      input.form-control(type="text" placeholder="Filtrar...", v-model="search")
      span.input-group-addon.glyphicon.glyphicon-filter(aria-hidden="true" style="top:0;")
    .mcl-items.max-height(style="background-color: white;")
      span(v-if="!isLoading")
        //.checkbox.text-left(v-if="selectMultiple")
          label(style="margin-left: 10px;")
            input(type="checkbox")
            span Selecionar todos

        .checkbox.text-left(v-for="(item, i) in displayed")
          label(style="margin-left: 10px; width:95%;")
            span.left(v-if="additionalInfo && additionalInfo.left") {{ item[additionalInfo.left] }}
            input(type="checkbox", v-model="selected[item[idSelection]]" v-on:click="select(item[idSelection])")
            span(style="color: black") {{ !parseField ? resolveObject(item) : parseField(resolveObject(item)) }}
            span.right(v-if="additionalInfo && additionalInfo.right") {{ item[additionalInfo.right] }}

      .checkbox.text-left(v-if="isLoading")
        label(style="margin-left: 10px;") Carregando
</template>

<script>
export default {
  props: {
    model: {
      required: true
    },
    idSelection: {
      'default': 'id'
    },
    callServer: {
      required: true
    },
    field: {
      required: true
    },
    customSeach: {},
    loading: {},
    selectMultiple: {
      'default': true
    },
    doRefetchOnUpdate: {},
    parseField: {},
    additionalInfo: {}
  },
  computed: {
    search: {
      get () {
        return this.$store.getters.search[this.model]
      },
      set (value) {
        this.$store.dispatch('search', {[this.model]: value})
      }
    },
    displayed () {
      const search = this.$store.getters.search[this.model] ? this.$store.getters.search[this.model].toLowerCase() : null

      if (!search || search === '') {
        return this.$store.getters[this.model]
      }

      if (!this.customSeach) {
        return this.$store.getters[this.model].filter(item => {
          return this.resolveObject(item).toLowerCase().includes(search)
        })
      } else {
        return this.$store.getters[this.model].filter(i => this.customSeach(i, search))
      }
    },
    selected: {
      get () {
        return this.$store.getters[this.model + 'Selected'].models
      }
    },
    isLoading () {
      if (this.loading) {
        return this.$store.getters[this.loading]
      } else {
        return false
      }
    }
  },
  created () {
    this.$store.dispatch(this.callServer)
    this.$store.watch(() => {
      return this.$store.getters[this.doRefetchOnUpdate]
    }, () => {
      this.$store.dispatch(this.callServer)
    })
  },
  methods: {
    select (id) {
      if (this.selectMultiple) {
        this.$store.dispatch('select', {
          model: this.model,
          id
        })
      } else {
        this.$store.dispatch('selectOne', {
          model: this.model,
          id
        })
      }
    },
    resolveObject (item) {
      const field = this.field.split('.')

      if (field.length === 1) {
        return item[field[0]]
      } else {
        return item[field[0]][field[1]]
      }
    }
  }
}
</script>

<style scoped>
  .max-height {
    min-height: 250px !important;
    max-height: 250px !important;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// CheckList.vue?1673bf64